'use client';

import { useEffect } from 'react';

import { getAnonymousId } from '@libs/api-proxy-client';

/**
 * @component
 * This component handles the setting of an anonymous ID using cookies. It checks if an anonymous ID
 * is already set in the cookies, and if not, it retrieves one asynchronously and sets it. The
 * functionality is only needed for CommerceTools cart.
 *
 * TODO: suggest turning into hook, not component.  Components should render UI or HTML
 */
export function AnonymousId() {
    useEffect(() => {
        getAnonymousId();
    }, []);

    return null;
}
